@import 'styles/mixins';
@import 'styles/variables';

.voiceContainer {
  display: flex;
  align-items: center;
  gap: 4px;
}

.createBrandVoice {
  padding: 0 12px 0 8px;
  border: 1px solid var(--neutral-10, rgba(45, 66, 91, 0.1));
  background: var(--neutral-0, #fff);
  svg > path {
    fill: var(--selected-stroke);
  }
  .voiceContainer {
    color: var(--selected-stroke);
  }
}

.editIcon {
  width: 22px;
  border-radius: 22px;

  // hack to 'nest' the icon further into the edge of the rounded div
  margin-right: -10px;
  display: none;

  &.selected {
    display: block;

    svg > path {
      fill: var(--selected-stroke);
    }
  }
}
